import { render, staticRenderFns } from "./ExportOrImportApplication.vue?vue&type=template&id=3a38d9f7&scoped=true"
import script from "./ExportOrImportApplication.vue?vue&type=script&lang=js"
export * from "./ExportOrImportApplication.vue?vue&type=script&lang=js"
import style0 from "./ExportOrImportApplication.vue?vue&type=style&index=0&id=3a38d9f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38d9f7",
  null
  
)

export default component.exports